import {Timestamp} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignVersionsState';
import {distanceInWords} from 'date-fns';

export class DateTimeUtil
{
    // private static _nowFn:Function =    window.performance &&
    //                                     window.performance.now &&
    //                                     window.performance.timing &&
    //                                     window.performance.timing.navigationStart?
    //                                         window.performance.now:
    //                                         Date.now;

    public static getNow():Timestamp
    {
        // return window.performance?window.performance.now():Date.now();
        return Date.now();
    }

    public static getRelativeString(timestamp:Timestamp):string
    {
        const now = DateTimeUtil.getNow();
        const options = {includeSeconds:true, addSuffix:true};

        return distanceInWords(now, timestamp, options);
    }

    public static toFormatString(timestamp:Timestamp, format:string):string
    {
        const dateString = (new Date(timestamp)).toString();

        // substr...
        // Tue Jun 11 2019 13:36:15 GMT+0300 (Moscow Standard Time)
        // 012345678901234567890123456789012
        return format
            .replace('MMM', dateString.substr(4, 3))
            .replace('DD', dateString.substr(8, 2))
            .replace('hh', dateString.substr(16,2))
            .replace('mm', dateString.substr(19,2))

        // substring...
        //  T u e   J u n   1 1   2 0 1 9   1 3 : 3 6 : 1 5   G M T + 0 3 0 0 (Moscow Standard Time)
        // 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 ...
        // 0         ^        10         ^        20         ^        30
        // return format
        //     .replace('MMM', dateString.substring(4, 7))
        //     .replace('DD', dateString.substring(8, 10))
        //     .replace('hh', dateString.substring(16,18))
        //     .replace('mm', dateString.substring(19,21))
    }
}
